export default __webpack_public_path__ + "static/media/chat-via-wa.2db603f8.svg";